import React from "react";
import GlobalContext from "./GlobalContext";
import ResultsDisplay from "./ResultsDisplay";
import ResultsPagination from "./ResultsPagination";

function ResultsList(){
  const global = React.useContext(GlobalContext);

  if(!global.state.initialized || global.state.error) return false;

  return (
    <div className="results-list">
      <ResultsDisplay />
      <ResultsPagination />
    </div>
  );
}

export default ResultsList;